module.exports = __webpack_public_path__ + "static/img/whrm.2b622b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/whrm.png
// module id = EwqI
// module chunks = 0